import React from 'react';
import { Button, Form } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import KeySettingsDisclosureV1022 from './KeySettingsDisclosureV1022';
import { KeyHelpV107 } from '../CommercialV106/KeyCommercialEditorV106';

export default function KeyLimitsV1022({
  inputs,
  onChange,
  setExpiredTime,
  open,
  setOpen,
  invalid,
}) {
  const { t, i18n } = useTranslation();
  const zh = (i18n?.resolvedLanguage || i18n?.language)?.startsWith('zh');
  const unlimited = zh ? '不限制' : 'Unlimited';
  const expiry =
    inputs.expired_time === -1
      ? t('token.edit.buttons.never_expire')
      : inputs.expired_time || (zh ? '尚未设置' : 'Not set');
  const rate =
    [
      Number(inputs.rpm_limit) > 0 ? `${inputs.rpm_limit} RPM` : '',
      Number(inputs.tpm_limit) > 0 ? `${inputs.tpm_limit} TPM` : '',
    ]
      .filter(Boolean)
      .join(' / ') || unlimited;
  const settings = (name) => ({
    name,
    open: Boolean(open[name]),
    onOpenChange: (value) =>
      setOpen((current) => ({ ...current, [name]: value })),
  });
  return (
    <div className='key-limits-v1022'>
      <KeySettingsDisclosureV1022
        {...settings('expiration')}
        title={t('token.edit.expire_time')}
        summary={expiry}
      >
        <div
          className='key-expiry-presets-v1022'
          role='group'
          aria-label={t('token.edit.expire_time')}
        >
          {[
            ['never_expire', 0, 0, 0, 0],
            ['expire_1_month', 1, 0, 0, 0],
            ['expire_1_day', 0, 1, 0, 0],
            ['expire_1_hour', 0, 0, 1, 0],
            ['expire_1_minute', 0, 0, 0, 1],
          ].map(([label, ...duration]) => (
            <Button
              key={label}
              type='button'
              size='small'
              active={label === 'never_expire' && inputs.expired_time === -1}
              onClick={() => setExpiredTime(...duration)}
            >
              {t(`token.edit.buttons.${label}`)}
            </Button>
          ))}
        </div>
        <Form.Input
          id='key-expiration-v1022'
          label={t('token.edit.expire_time')}
          name='expired_time'
          onChange={onChange}
          value={inputs.expired_time === -1 ? '' : inputs.expired_time}
          type='datetime-local'
          step='1'
          error={
            invalid.expiration
              ? t('token.edit.messages.expire_time_invalid')
              : false
          }
          aria-invalid={Boolean(invalid.expiration)}
        />
      </KeySettingsDisclosureV1022>
      <KeySettingsDisclosureV1022
        {...settings('rate')}
        title={zh ? '请求数限制' : 'Request limits'}
        summary={rate}
      >
        <Form.Group widths='equal'>
          <Form.Input
            id='key-rpm-v1022'
            label={t('token.edit.rpm_limit')}
            name='rpm_limit'
            min='0'
            step='1'
            inputMode='numeric'
            onChange={onChange}
            value={inputs.rpm_limit ?? 0}
            type='number'
            error={Boolean(invalid.rate)}
            aria-invalid={Boolean(invalid.rate)}
          />
          <Form.Input
            id='key-tpm-v1022'
            label={t('token.edit.tpm_limit')}
            name='tpm_limit'
            min='0'
            step='1'
            inputMode='numeric'
            onChange={onChange}
            value={inputs.tpm_limit ?? 0}
            type='number'
            error={Boolean(invalid.rate)}
            aria-invalid={Boolean(invalid.rate)}
          />
        </Form.Group>
        {invalid.rate && (
          <p role='alert' className='retry-error-v1021'>
            {t('token.edit.messages.rate_limit_invalid')}
          </p>
        )}
        <KeyHelpV107
          label={zh ? '请求数限制说明' : 'Request limit help'}
          content={t('token.edit.rate_limit_notice')}
        />
      </KeySettingsDisclosureV1022>
      <KeySettingsDisclosureV1022
        {...settings('ip')}
        title={t('token.edit.ip_limit')}
        summary={inputs.subnet?.trim() || unlimited}
      >
        <Form.Input
          id='key-ip-v1022'
          label={t('token.edit.ip_limit')}
          name='subnet'
          placeholder={t('token.edit.ip_limit_placeholder')}
          onChange={onChange}
          value={inputs.subnet || ''}
          autoComplete='new-password'
        />
      </KeySettingsDisclosureV1022>
    </div>
  );
}
